import { render, staticRenderFns } from "./LawProfessionalInvestigationRegionList.vue?vue&type=template&id=53e1c0ec&"
import script from "./LawProfessionalInvestigationRegionList.vue?vue&type=script&lang=js&"
export * from "./LawProfessionalInvestigationRegionList.vue?vue&type=script&lang=js&"
import style0 from "./LawProfessionalInvestigationRegionList.vue?vue&type=style&index=0&id=53e1c0ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports